import React, { useContext, useReducer } from 'react';
import impostoReducer, { initialState } from './impostoReducer';

/**
 * baseado em
 *
 * https://kentcdodds.com/blog/how-to-use-react-context-effectively
 * https://kentcdodds.com/blog/how-to-optimize-your-context-value
 */
const ImpostoStateContext = React.createContext();
const ImpostoDispatchContext = React.createContext();

function ImpostoProvider({ children }) {
  const [state, dispatch] = useReducer(impostoReducer, initialState);

  return (
    <ImpostoStateContext.Provider value={state}>
      <ImpostoDispatchContext.Provider value={dispatch}>{children}</ImpostoDispatchContext.Provider>
    </ImpostoStateContext.Provider>
  );
}

function ImpostoConsumer({ children }) {
  return (
    <ImpostoStateContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('ImpostoConsumer must be used within a ImpostoProvider');
        }
        return children(context);
      }}
    </ImpostoStateContext.Consumer>
  );
}

function useImpostoState() {
  const context = useContext(ImpostoStateContext);
  if (context === undefined) {
    throw new Error('useImpostoState must be used within a ImpostoProvider');
  }
  return context;
}

function useImpostoDispatch() {
  const context = useContext(ImpostoDispatchContext);
  if (context === undefined) {
    throw new Error('useImpostoDispatch must be used within a ImpostoProvider');
  }
  return context;
}

function useImposto() {
  return [useImpostoState(), useImpostoDispatch()];
}

export { ImpostoProvider, ImpostoConsumer, useImposto };
